import { render, staticRenderFns } from "./OrderzhipeiDetails.vue?vue&type=template&id=e4afde7a&scoped=true"
import script from "./OrderzhipeiDetails.vue?vue&type=script&lang=js"
export * from "./OrderzhipeiDetails.vue?vue&type=script&lang=js"
import style0 from "./OrderzhipeiDetails.vue?vue&type=style&index=0&id=e4afde7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4afde7a",
  null
  
)

export default component.exports